import { threads } from "@/mocks/home";

const toneMap: Record<string, string> = {
  primary: "bg-primary-500 text-background-50 dark:text-foreground-950",
  secondary: "bg-secondary-500 text-background-50 dark:text-foreground-950",
  accent: "bg-accent-500 text-accent-950",
};

export default function CommunityBoard() {
  return (
    <section id="board" className="w-full px-4 md:px-8 mt-14 md:mt-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
        <div className="lg:col-span-8">
          <div className="flex items-center justify-between mb-5 md:mb-6">
            <div>
              <span className="font-label text-xs tracking-[0.3em] text-primary-600">讨论区</span>
              <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                读者正在补充的细节
              </h2>
            </div>
            <span className="hidden sm:inline-flex items-center gap-1.5 font-label text-xs text-foreground-400 whitespace-nowrap">
              <i className="ri-refresh-line"></i>
              实时刷新
            </span>
          </div>

          <div className="flex flex-col gap-3">
            {threads.map((thread) => (
              <article
                key={thread.title}
                className="group rounded-lg border border-background-200/80 bg-background-50 p-4 md:p-5 hover:border-primary-300 transition-colors"
              >
                <div className="flex items-start gap-3.5">
                  <span
                    className={`w-10 h-10 shrink-0 flex items-center justify-center rounded-md font-heading font-bold ${
                      toneMap[thread.avatarTone]
                    }`}
                  >
                    {thread.avatar}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                      <span className="font-label text-sm font-medium text-foreground-800">
                        {thread.author}
                      </span>
                      {thread.hot && (
                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-primary-100 text-primary-700 font-label text-[11px]">
                          <i className="ri-fire-line"></i>
                          热帖
                        </span>
                      )}
                      <span className="font-label text-[11px] text-foreground-400">
                        {thread.time}
                      </span>
                    </div>
                    <h3 className="mt-2 font-heading text-base md:text-lg font-semibold leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors">
                      {thread.title}
                    </h3>
                    <p className="mt-2 font-label text-sm leading-relaxed text-foreground-600">
                      {thread.excerpt}
                    </p>
                    <div className="mt-3.5 flex items-center gap-5 font-label text-xs text-foreground-400">
                      <span className="inline-flex items-center gap-1.5">
                        <i className="ri-chat-3-line"></i>
                        {thread.replies} 条回复
                      </span>
                      <span className="inline-flex items-center gap-1.5">
                        <i className="ri-thumb-up-line"></i>
                        {thread.likes}
                      </span>
                      <span className="inline-flex items-center gap-1.5 text-primary-600 cursor-pointer whitespace-nowrap">
                        参与讨论
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>

        <aside className="lg:col-span-4">
          <div className="lg:sticky lg:top-28 flex flex-col gap-4">
            <div className="rounded-lg bg-secondary-950 p-6 text-background-50">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-background-50/10">
                <i className="ri-megaphone-line"></i>
              </span>
              <h3 className="mt-4 font-heading text-xl font-bold">你手里的细节，可能正是缺口</h3>
              <p className="mt-3 font-label text-sm leading-relaxed text-background-50/70">
                匿名投稿同样会被认真对待。我们只核实事实，不公开信源身份，
                每一条被采用的线索都会收到回执。
              </p>
              <button
                type="button"
                className="mt-5 w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-accent-500 text-accent-950 font-label text-sm hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-lock-2-line"></i>
                匿名提交
              </button>
            </div>

            <div className="rounded-lg border border-background-200/80 bg-background-50 p-5">
              <h3 className="font-heading text-base font-semibold text-foreground-950">
                社区守则速览
              </h3>
              <ul className="mt-4 space-y-3">
                {[
                  "只讨论可核实的事实，不针对个人进行攻击",
                  "引用他人材料请注明来源与时间",
                  "存疑内容请标注「待确认」",
                  "发现出入欢迎在讨论区提出更正",
                ].map((rule) => (
                  <li key={rule} className="flex items-start gap-2.5">
                    <span className="mt-0.5 w-4 h-4 shrink-0 flex items-center justify-center text-secondary-600">
                      <i className="ri-checkbox-circle-line text-sm"></i>
                    </span>
                    <span className="font-label text-sm leading-snug text-foreground-600">
                      {rule}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}